import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { PurePmInEditorDirectStreamingPluginState } from './types';

export const purePmInEditorDirectStreamingPluginKey =
	new PluginKey<PurePmInEditorDirectStreamingPluginState>('purePmInEditorDirectStreaming');
